import { createAsyncSelectors } from '@lib/selectors';

export const getDataDictionarySelector = createAsyncSelectors((state) => state.core.dataDictionary.get);
